import type { CategorySlug } from "@/api/types";

export const CATEGORY_LABELS: Record<CategorySlug, string> = {
  "3d": "3D",
  systems: "Systems",
  vehicles: "Vehicles",
  scripts: "Scripts",
  materials: "Materials & Textures",
  plugins: "Plugins",
  maps: "Maps",
  ui: "UI",
  vfx: "VFX",
  audio: "Audio",
  animations: "Animations",
};

/**
 * Every category slug in navigation order, free of UI imports so the server can use it. The
 * marketplace's `CATEGORY_SLUGS` (pages/marketplace/categories.ts) lists the same slugs in the same order.
 */
export const CATEGORY_SLUGS = Object.keys(CATEGORY_LABELS) as CategorySlug[];
